import { css, html } from "../helpers/webComponents";
import { CanvasComponent } from "./CanvasComponent";

/**
 * Represents the start screen.
 */
export class StartComponent extends CanvasComponent {
    /**
     * @inheritdoc
     */
    protected styles(): string {
        return css`
            :host {
                --background-color: rgba(1, 1, 1, 0.6);
                --padding: 20px;
                --border-radius: 10px;
                --blur: 10px;
            }

            .title {
                margin-top: 0;
                background-color: var(--background-color);
                padding: var(--padding);
                backdrop-filter: blur(var(--blur));
                border-radius: var(--border-radius);
                box-shadow: var(--box-shadow);
            }

            .title h1 {
                margin: 0;
            }

            .buttons {
                display: flex;
            }

            .wrapper {
                justify-content: space-evenly;
                align-items: center;
            }

            .footer {
                background: 0;
                padding: 0;
            }

            .footer .button {
                background-color: var(--background-color);
                padding: var(--padding);
                margin: 0;
                backdrop-filter: blur(var(--blur));
                border-radius: var(--border-radius);
                box-shadow: var(--box-shadow);
            }

            .footer .button:hover {
                background-color: rgba(1, 1, 1, 0.8);
            }
        `;
    }

    /**
     * @inheritdoc
     */
    protected renderBody(): HTMLElement {
        return html`
            <div class="wrapper">
                ${this.renderTitle()}
                ${this.renderFooter()}
            </div>
        `;
    }

    /**
     * @inheritdoc
     */
    protected renderTitle(): string {
        const roomName: string | undefined = this._currentGameState?.roomName;

        return `
            <div class="title">
                <h1>${roomName}</h1>
            </div>
        `;
    }

    /**
     * @inheritdoc
     */
    protected renderContent(): string {
        return `
            <div class="content">
                ${this.renderContentText()}
            </div>
        `;
    }

    /**
     * @inheritdoc
     */
    protected renderFooter(): HTMLElement {
        return html`
            <div class="footer">
                ${this._currentGameState?.actions.map(button => this.renderActionButton(button))}
            </div>
        `;
    }
};
